export const contactsTableHeader = () => {
  return [
    {
      name: "Email",
      field: "email",
      align: "left",
      sorting: false,
    },
    {
      name: "Name",
      field: "name",
      align: "left",
    },
    {
      name: "Status",
      field: "status",
      align: "left",
      sorting: false,
    },
    {
      name: "Created On",
      field: "createdOn",
      align: "left",
      sorting: false,
    },
  ];
};

export const contactsOptions = [
  {
    label: "All Contacts",
    value: "all",
  },
  {
    label: "Team's Contacts",
    value: "team",
  },
  {
    label: "My Contacts",
    value: "my",
  },
];

export const getContactStatus = (status: number) => {
  if (status === 0) {
    return "Unsubscribed";
  }
  if (status === 1) {
    return "Subscribed";
  }
};
